import { Injectable } from '@angular/core';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { AssignementNotAcceptingListingModel, AssignmentNotAcceptingGridParams } from 'common/models/page-models/Assignment Non Accepted Model/assignment-non-accepted-params.model';


@Injectable({
    providedIn: 'root'
})
export class AssigmentNotAcceptedGridDataService extends GridDataService<AssignementNotAcceptingListingModel, AssignmentModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.assigementNotAccepted, http, ss);
    }

    createInstance(): AssignementNotAcceptingListingModel {
        return new AssignementNotAcceptingListingModel();
    }

    // override getGridParams(param): GridPostParams {

    //     return new AssignmentNotAcceptingGridParams();
    // }

    override getGridParams(param): GridPostParams {
        console.log(param);
        
        let params;
        params = new AssignmentNotAcceptingGridParams();
        params.id = param.id;
        console.log(params);
        
        return params;
    }

    override getDataParam() {
        // console.log("DATA PARAMS", this.getDataParam);
        return 'student_info';
    }
    
    override getExtraParam() {
        return 'details';
      }
    getDeleteUrl() {
        return '';
    }

    override transformDataModel(data: any, param) {
        super.transformDataModel(data, param);
        if (data.details && data.details.student_info) {
            data.details.student_info.forEach((data) => {
                data.student_feedback = data.student_feedback === '' ? 'N/A' : data.student_feedback;
                data.trainer_feedback_to_student = data.trainer_feedback_to_student === '' ? 'N/A' : data.trainer_feedback_to_student;
                data.trainer_feedback_to_admin = data.trainer_feedback_to_admin === '' ? 'N/A' : data.trainer_feedback_to_admin;
    
            });
            data.student_info = data.details.student_info
        }
   
        console.log(data);
        
        return data;
    }

}
